export function getTranslateXY(element: HTMLElement) {
  const style = window.getComputedStyle(element)
  const matrix = new DOMMatrixReadOnly(style.transform)
  return {
    translateX: matrix.m41,
    translateY: matrix.m42
  }
}

export function targetOrParentHasClass(element: EventTarget | null | undefined, className: string): boolean {
  if (!element || !(element instanceof Element)) {
    return false
  }

  if (element.classList.contains(className)) {
    return true
  }
  if (element.parentElement) {
    return targetOrParentHasClass(element.parentElement, className)
  }
  return false
}

export function isContextMenuClick(event: MouseEvent) {
  return event.button === 2 || (event.button === 0 && event.ctrlKey)
}
